<template>
  <span class="euro-amount">
    <template v-if="show">
      <span v-if="value === 0.0">
        <!-- For some reason vue-numeric doesn't always render 0.0 -->
        0,00 €
      </span>
      <vue-numeric v-else
                   :value="value"
                   separator="."
                   v-bind:precision=2
                   v-bind:read-only=true
                   currency="€"
                   currency-symbol-position="suffix">
      </vue-numeric>
    </template>
  </span>
</template>

<script>
import VueNumeric from 'vue-numeric';

export default {
  name: "euro-amount",
  components: {
    VueNumeric,
  },
  props: [
    'value',
  ],
  computed: {
    show() {
      if (this.value === undefined) return false
      if (this.value === null) return false
      return !isNaN(this.value)
    },
  },
}
</script>

<style scoped>
.euro-amount {
  white-space: nowrap;
}
</style>
